// src/api/kentyouEye.js

// Read runtime env (provided by /env.js). Falls back to current constants.
const RUNTIME = (window.__ENV__ || {});
const BASE_URL = (RUNTIME.EYE_BASE || "https://cognifog.kentyou.com/eye/rest").replace(/\/$/, "");
const AUTH_HEADER = RUNTIME.EYE_BASIC_AUTH || "Basic Y29nbmlmb2c6Y29nbmlmb2c=";

/**
 * Helper: fetch JSON from anywhere under /eye/rest
 * Throws if response.ok === false
 */
async function fetchJSON(path) {
  const res = await fetch(`${BASE_URL}${path}`, {
    headers: {
      Authorization: AUTH_HEADER,
      Accept: "application/json",
    },
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API ${path} failed: ${res.status} ${res.statusText} – ${text}`);
  }
  return res.json();
}

// 1) Get all koncepts under sensinact "cognifog"
export function getAllKoncepts() {
  return fetchJSON(`/sensinacts/cognifog/koncepts/`);
}

// 2) Get kapabilities array for a given konceptId
export function getKapabilities(konceptId) {
  return fetchJSON(`/sensinacts/cognifog/koncepts/${konceptId}/kapabilities`);
}

// 3) Get a single kapability’s data (returns an object with .data.value and .data.timestamp)
export function getKapabilityData(konzeptId, kapabilityId) {
  const encId = encodeURIComponent(kapabilityId); // tilde-safe, etc.
  return fetchJSON(`/sensinacts/cognifog/koncepts/${konzeptId}/kapabilities/${encId}`);
}

// 4) Get paginated GeoJSON (pageSize = 50). Call first with continuationToken=""
export function getGeoJSON(pageSize = 50, continuationToken = "") {
  const tokenParam = continuationToken ? `&continuationToken=${encodeURIComponent(continuationToken)}` : "";
  return fetchJSON(`/koncepts/geojson?pageSize=${pageSize}${tokenParam}`);
}
